import { Box, Button, Typography } from '@mui/material';
import LangEnum from '../../../../../../../../../../../../../../lang/LangEnum';
import useTeceoStyles from '../../../../../../../../../../../../../../useTeceoStyles';
import { useApplicationContext } from '../../../../../../../../../../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../../../../../../../../../../translation/TranslationContext';
import { useChatContext } from '../../../../../../../../../../../../contexts/chat/chat.context';
import { Message } from '../../../../../../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.types';
import { isVideoCallMessageType } from '../../../../../../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.utils';

interface VideoCallMessageProps {
  message: Message;
}

const getMessageColor = (currentMessage: Message) => {
  if (currentMessage.error) {
    return 'error';
  }
  const isSending = currentMessage.tempId && !currentMessage.id;
  return isSending ? 'textSecondary' : 'textPrimary';
};

const VideoCallMessage = ({ message }: VideoCallMessageProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const { translate } = useTranslation();
  const { videoCall, onClickJoinVideoCall, onClickDeleteVideoCall, activeChat } = useChatContext();
  const { team } = useApplicationContext();
  const isMessageOfUser = message.user.id === team?.userId;

  const isVideoCallInProgress =
    isVideoCallMessageType(message) &&
    message.data?.active &&
    message.data?.meetingId &&
    message.data.meetingId === activeChat?.inProgressVideoCall?.meetingId;

  const messageColor = getMessageColor(message);

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="body2" color={messageColor} className={teceoClasses.secondaryTypography}>
        {isVideoCallInProgress
          ? translate(LangEnum.STARTED_VIDEO_CALL_MESSAGE)
          : translate(LangEnum.DELETED_VIDEO_CALL_MESSAGE)}
      </Typography>
      {isVideoCallInProgress && (
        <Box display="flex" flexDirection="column" rowGap="8px">
          <Button
            variant="contained"
            color="primary"
            onClick={onClickJoinVideoCall}
            disabled={message.data?.meetingId === videoCall?.meetingId}
          >
            {translate(LangEnum.ENTER_VIDEO_CALL_BUTTON_LABEL)}
          </Button>
          {isMessageOfUser && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => onClickDeleteVideoCall(message.data?.chat?.id)}
              disabled={message.data?.meetingId === videoCall?.meetingId}
            >
              {translate(LangEnum.CLOSE_VIDEO_CALL_BUTTON_LABEL)}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default VideoCallMessage;
